<template>
	<div id="pageRoot">

		<span class="pageInstruction" style="left: 88px; top: 30px;">
			<p>Escribe otra palabra que rime y luego dibújala.</p>
		</span>

		<span class="pageInstruction" style="left: 88px; top: 85px;">
			<p>Sube fotos de tus dibujos</p>
		</span>

		<p class="page-tag-blind-alternative" style="left: 105px; top: 140px; padding: 0px 0px 0px 0px; width: 235px;">
			VOLAR
		</p>
		<saved-input-narrator-friendly v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
		<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" style="position: absolute; margin-left: 12.4%; margin-top: 54%;" number=2 textColor="#FFFF00"></image-upload>
		<uploaded-image class="pageElement picture-slot-blind hover-animation-b" v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 style="left: 116px; top: 310px; width: 220px; height: 312px;"></uploaded-image>

		<p class="page-tag-blind-alternative" style="left: 380px; top: 140px;  padding: 0px 0px 0px 0px; width: 235px;">
			CANILLA
		</p>
		<saved-input-narrator-friendly v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>
		<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" style="position: absolute; margin-left: 39.1%; margin-top: 54%;" number=3 textColor="#FFFF00"></image-upload>
		<uploaded-image class="pageElement picture-slot-blind hover-animation-b" v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 style="left: 390px; top: 310px; width: 220px; height: 312px;"></uploaded-image>

		<p class="page-tag-blind-alternative" style="left: 655px; top: 140px;  padding: 0px 0px 0px 0px; width: 235px;">
			CERRO
		</p>
		<saved-input-narrator-friendly v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03"/>
		<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" style="position: absolute; margin-left: 65.9%; margin-top: 54%;" number=4 textColor="#FFFF00"></image-upload>	
		<uploaded-image class="pageElement picture-slot-blind hover-animation-b" v-bind:page="$parent.page" v-bind:type="$parent.type" number=4 style="left: 665px; top: 310px; width: 220px; height: 312px;"></uploaded-image>		

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#inputField01
{
font-size: 26px;
position: absolute;
width: 219px;
height: 35px;
left: 106px;
top: 225px;
position:absolute;
z-index: 3;
}
#inputField02
{
font-size: 28px;
position: absolute;
width: 219px;
left: 381px;
top: 225px;
position:absolute;
z-index: 3;
}
#inputField03
{
font-size: 28px;
position: absolute;
width: 219px;
left: 656px;
top: 225px;
position:absolute;
z-index: 3;
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>